var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNormalOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.58333C2.86193 9.58333 2.75 9.4714 2.75 9.33333V3C2.75 2.86193 2.86193 2.75 3 2.75H7.66667C7.80474 2.75 7.91667 2.86193 7.91667 3V9.33333C7.91667 9.47141 7.80474 9.58333 7.66667 9.58333H3ZM3 16.25C2.86193 16.25 2.75 16.1381 2.75 16V13C2.75 12.8619 2.86193 12.75 3 12.75H7.66667C7.80474 12.75 7.91667 12.8619 7.91667 13V16C7.91667 16.1381 7.80474 16.25 7.66667 16.25H3ZM11.3333 16.25C11.1953 16.25 11.0833 16.1381 11.0833 16V9.66667C11.0833 9.52859 11.1953 9.41667 11.3333 9.41667H16C16.1381 9.41667 16.25 9.52859 16.25 9.66667V16C16.25 16.1381 16.1381 16.25 16 16.25H11.3333ZM11.0833 3C11.0833 2.86193 11.1953 2.75 11.3333 2.75H16C16.1381 2.75 16.25 2.86193 16.25 3V6C16.25 6.13807 16.1381 6.25 16 6.25H11.3333C11.1953 6.25 11.0833 6.13807 11.0833 6V3Z",
    stroke: "#2B2C2D",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalOne);
export default __webpack_public_path__ + "static/media/normal-one.22d4d096ecfed497dd4195c65083899e.svg";
export { ForwardRef as ReactComponent };